<form #mainFrm="ngForm" class="layout-col full">
  @let schedule = schedule$ | async;
  <elder-single-pane-wrapper class="flex">
    <elder-pane-header>
      <elder-pane-title>
        {{ 'schedules.detail' | translate }}
      </elder-pane-title>

      <elder-pane-actions>
        <button mat-icon-button [disabled]="mainFrm.invalid || !schedule" (click)="save($event)">
          <mat-icon>save</mat-icon>
        </button>
      </elder-pane-actions>
    </elder-pane-header>

    @if (schedule) {
      <elder-pane-content class="layout-col">
        <elder-pane-subtitle>{{ 'context.general' | translate }}</elder-pane-subtitle>
        <!-- Name input -->
        <div class="flex-none layout-row gap-sm">
          <mat-form-field>
            <mat-label>{{ 'context.name' | translate }}</mat-label>
            <input
              matInput
              name="name"
              #idModel="ngModel"
              required
              placeholder="{{ 'context.name' | translate }}"
              [(ngModel)]="schedule.name"
            />
            @if (idModel?.errors?.['required']) {
              <mat-error>{{ 'validations.required' | translate }}</mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Interval Edit -->
        <div class="flex-none layout-row gap-sm">
          <mat-form-field elderIntervalPickerBinding>
            <elder-interval-input
              required
              [(isoValue)]="schedule.validityInterval"
              [mode]="'date-range'"
            >
            </elder-interval-input>
            <elder-interval-picker-toggle matIconSuffix></elder-interval-picker-toggle>
          </mat-form-field>
        </div>
        <elder-pane-subtitle>{{ 'schedules.week' | translate }}</elder-pane-subtitle>
        <app-weekly-schedule-edit class="flex" [weekSchedule]="schedule?.weekSchedule">
        </app-weekly-schedule-edit>
      </elder-pane-content>
    }
  </elder-single-pane-wrapper>
</form>
